var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, ViewChild } from '@angular/core';
import { ImportIntoConfigureGalleryDto, ImportUserGraphIntoConfigureGalleryDto } from '../../../../../shared/service-proxies/service-proxies';
import { Subject } from 'rxjs';
import { GraphicsType } from '../../../shared/helpers/graphics-type-help';
import { GraphImportControlSettingComponent } from '../control/graph-import-control-setting.component';
import { finalize } from 'rxjs/operators';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
var GallerySettingModalComponent = /** @class */ (function (_super) {
    __extends(GallerySettingModalComponent, _super);
    function GallerySettingModalComponent(injector, systemGalleryService, userGalleryAppSerivceService, modalService, bsModalRef, elRef) {
        var _this = _super.call(this, injector) || this;
        _this.systemGalleryService = systemGalleryService;
        _this.userGalleryAppSerivceService = userGalleryAppSerivceService;
        _this.modalService = modalService;
        _this.bsModalRef = bsModalRef;
        _this.elRef = elRef;
        _this.currentType = GraphicsType.system;
        _this.saving = false;
        _this.sysType = GraphicsType.system;
        _this.userType = GraphicsType.user;
        _this._onClosed = new Subject();
        return _this;
    }
    Object.defineProperty(GallerySettingModalComponent.prototype, "onClosed", {
        get: function () {
            return this._onClosed;
        },
        enumerable: true,
        configurable: true
    });
    GallerySettingModalComponent.prototype.ngOnInit = function () {
        this.sys = 'sys' + Math.floor(Math.random() * 10 + 1);
        this.user = 'user' + Math.floor(Math.random() * 10 + 1);
        $(this.elRef.nativeElement).parent('.modal-content').draggable({
            cursor: 'pointer',
            handle: '.modal-header'
        });
        this.gallerySysComponent.loadGraphCategoies();
        this.galleryUserComponent.loadUserGroups();
    };
    GallerySettingModalComponent.prototype.changeGraph = function (value) {
        if (value) {
            if (value.graphicsType === GraphicsType.system) {
                this.currentSysGraph = value;
            }
            else {
                this.currentUserGraph = value;
            }
        }
    };
    GallerySettingModalComponent.prototype.save = function () {
        this.saving = true;
        if (this.currentType === GraphicsType.system) {
            this.systemGraphSave();
        }
        else {
            this.userGraphSave();
        }
    };
    GallerySettingModalComponent.prototype.systemGraphSave = function () {
        var _this = this;
        var input = new ImportIntoConfigureGalleryDto();
        input.configureId = this.configureId;
        input.categoryId = this.currentSysGraph.categoryId;
        input.graphId = this.currentSysGraph.graphId;
        input.name = this.currentSysGraph.name;
        this.systemGalleryService.importIntoConfigureGallery(input).pipe(finalize(function () { return _this.saving = false; }))
            .subscribe(function (r) {
            if (r === 0) {
                _this.close({ importedGraphName: _this.currentSysGraph.name });
                _this.notify.info(_this.l('SavedSuccessfully'));
            }
            else {
                _this.currentSysGraph.id = r;
                var modalRef = _this.modalService.show(GraphImportControlSettingComponent, {
                    initialState: { graphState: _this.currentSysGraph, configureId: _this.configureId },
                    backdrop: 'static', class: 'graphImportControlSettingModal'
                });
                var onClosedSub_1 = modalRef.content.onClosed.subscribe(function (result) {
                    if (result) {
                        _this.close({ importedGraphName: result.graphName });
                    }
                    onClosedSub_1.unsubscribe();
                });
            }
        });
    };
    GallerySettingModalComponent.prototype.userGraphSave = function () {
        var _this = this;
        if (this.currentUserGraph.list.length > 0) {
            this.userGraphInput = new ImportUserGraphIntoConfigureGalleryDto();
            this.userGraphInput.userGalleryId = this.currentUserGraph.userGalleryId;
            this.userGraphInput.configureId = this.configureId;
            this.userGraphInput.userGraphId = this.currentUserGraph.graphId;
            this.userGraphInput.userGraphName = this.currentUserGraph.name;
            this.userGalleryAppSerivceService.importUserGraphIntoConfigureGallery(this.userGraphInput)
                .pipe(finalize(function () { return _this.saving = false; }))
                .subscribe(function (r) {
                if (r === 0) {
                    _this.close({ importedGraphName: _this.currentUserGraph.name });
                    _this.notify.info(_this.l('SavedSuccessfully'));
                }
                else {
                    _this.currentUserGraph.id = r;
                    var modalRef = _this.modalService.show(GraphImportControlSettingComponent, {
                        initialState: { graphState: _this.currentUserGraph, configureId: _this.configureId },
                        backdrop: 'static', class: 'graphImportControlSettingModal'
                    });
                    var onClosedSub_2 = modalRef.content.onClosed.subscribe(function (result) {
                        if (result) {
                            _this.close({ importedGraphName: result.graphName });
                        }
                        onClosedSub_2.unsubscribe();
                    });
                }
            }, function (err) {
                _this.galleryUserComponent.loadUserGroups();
            });
        }
        else {
            this.saving = false;
            abp.message.info(this.lc('selectedGalleryInfo'));
        }
    };
    GallerySettingModalComponent.prototype.close = function (modalResult) {
        this.bsModalRef.hide();
        this._onClosed.next(modalResult);
        this._onClosed.complete();
    };
    GallerySettingModalComponent.prototype.loadUserGroups = function () {
        this.galleryUserComponent.loadUserGroups();
    };
    GallerySettingModalComponent.prototype.selectCurrentType = function (type) {
        this.currentType = type;
    };
    __decorate([
        ViewChild('galleryUser', { static: true })
    ], GallerySettingModalComponent.prototype, "galleryUserComponent", void 0);
    __decorate([
        ViewChild('gallerySys', { static: true })
    ], GallerySettingModalComponent.prototype, "gallerySysComponent", void 0);
    GallerySettingModalComponent = __decorate([
        Component({
            selector: 'gallery-setting-modal',
            styles: [".padding-top-10 { padding-top: 10px; } ",
                ".element-setting-base{ .inline-label { margin: 10px 0px 0px 10px; display: inline-block; } .border-group { // border: 1px solid #ddd; padding: 5px; margin-bottom: 0px; } .inline-selector { display: inline-block; margin: 5px 0px; } .inline-variable { display: inline-block; margin: 5px 0px; } .inline-input { display: inline-block; margin: 5px 0px; }     } .date-time-setting-modal { .modal-content { width: 600px; } .cursor-pointer{ cursor: pointer; } .recode-input{ width: calc(100% - 70px); border: 1px solid #d7dbe5;   padding:  5px 10px; } textarea.noResize { resize: none; } } .toggleViewSettingModal { .modal-content { width: 600px; } } .textSettingModal { .modal-content { width: 600px; } } "],
            template: "<div class=\"fe-modal-container element-setting-base\"> <form class=\"configure\" #gallerySettingForm=\"ngForm\" novalidate (ngSubmit)=\"save()\"> <div class=\"modal-header fe-modal-header\"> <h4 class=\"fe-modal-header-title\"> {{lc(\"Gallery\")}} </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"top-line\"></div> <div class=\"fe-modal-middle\"> <div class=\"fe-modal-body\"> <tabset class=\"tab-container tabbable-line\"> <tab heading=\"{{lc('SystemGallery')}}\" customClass=\"m-tabs__item\" id=\"{{sys}}\" (selectTab)=\"selectCurrentType(1)\"> <gallery-sys #gallerySys graphType=\"gallerySettingModal\" (selectedGraphChange)=\"changeGraph($event)\"></gallery-sys> </tab> <tab heading=\"{{lc('UserGallery')}}\" customClass=\"m-tabs__item\" id=\"{{user}}\" (selectTab)=\"selectCurrentType(0)\"> <gallery-user #galleryUser (selectedGraphChange)=\"changeGraph($event)\"></gallery-user> </tab> </tabset> </div> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [buttonBusy]=\"saving\" [disabled]=\"!gallerySettingForm.form.valid\"> {{l(\"Save\")}} </button> </div> </div> </form> </div>"
        })
    ], GallerySettingModalComponent);
    return GallerySettingModalComponent;
}(ConfigureComponentBase));
export { GallerySettingModalComponent };
